module.exports = __webpack_public_path__ + "static/media/Double Mat with Writing and Logo.55dd45aa.png";